var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantBubbleIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 36 36",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st1 {\n        stroke: url(#linear-gradient1);\n        stroke-width: .5px;\n      }\n\n      .st2 {\n        fill: url(#radial-gradient);\n        isolation: isolate;\n        opacity: .8;\n      }\n\n      .st3 {\n        fill: #d9d9d9;\n        fill-opacity: .2;\n      }\n\n      .st4 {\n        fill: url(#linear-gradient);\n      }\n\n      .st5 {\n        fill: #fff;\n        fill-opacity: 0;\n      }\n\n      .st6 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st7 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,0h0c9.9,0,18,8.1,18,18s-8.1,18-18,18S0,27.9,0,18,8.1,0,18,0Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 18,
    cy: 17.8,
    fx: 18,
    fy: 28.3,
    r: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6367c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6367c3",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6367c3",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6367c3",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6367c3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 18,
    cy: 11,
    fx: 18,
    fy: 11,
    r: 10.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bcbef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbef6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbef6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 18,
    y1: 862,
    x2: 18,
    y2: 898,
    gradientTransform: "translate(0 -862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6367c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a7ee8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 18,
    y1: 862,
    x2: 18,
    y2: 898,
    gradientTransform: "translate(0 -862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 18,
    cy: 17.8,
    r: 17.5,
    "data-figma-bg-blur-radius": 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 18,
    cy: 11,
    r: 10.7
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 18,
    cy: 18,
    r: 18,
    "data-figma-bg-blur-radius": 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18,
    cy: 18,
    r: 17.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantBubbleIcon2);
export default __webpack_public_path__ + "static/media/assistant-bubble-icon2.6cb1a2ab4b2b86fe504078c7905602f5.svg";
export { ForwardRef as ReactComponent };